import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { getCurrentUser } from 'aws-amplify/auth';
import AuthForm from './components/AuthForm';
import Dashboard from './components/Dashboard';
import ApplicationDetail from './components/ApplicationDetail';
import InterviewersManagement from './components/InterviewersManagement';
import amplifyconfig from './amplifyconfiguration.json';
import './App.css';

Amplify.configure(amplifyconfig);

function App() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthState();
  }, []);

  const checkAuthState = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      console.log('No authenticated user');
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAuthSuccess = () => {
    checkAuthState();
  };

  const handleSignOut = () => {
    setUser(null);
  };

  if (isLoading) {
    return null;
  }

  return (
    <Router>
      <div className="App">
        <div className="video-background">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="background-video"
          >
            <source
              src="https://video.wixstatic.com/video/9a33be_ea5e9f4fa1b34803ba0c6f6bf3d1553e/1080p/mp4/file.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="content-overlay">
          {user ? (
            <Routes>
              <Route path="/dashboard" element={<Dashboard user={user} onSignOut={handleSignOut} />} />
              <Route path="/application/:id" element={<ApplicationDetail user={user} onSignOut={handleSignOut} />} />
              <Route path="/interviewers" element={<InterviewersManagement user={user} onSignOut={handleSignOut} />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          ) : (
            <AuthForm onAuthSuccess={handleAuthSuccess} />
          )}
        </div>
      </div>
    </Router>
  );
}

export default App;
